module.exports = __webpack_public_path__ + "img/5.31f3b344.png";